import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UserPositionFacade } from '@pf/platform-core/domain';
import { SharedUiModule } from '@pf/shared-ui';
import { startCase } from 'lodash-es';
import { map } from 'rxjs';

@Component({
    selector: 'cpw-task-layout',
    standalone: true,
    imports: [AsyncPipe, SharedUiModule],
    templateUrl: './cpw-task-layout.component.html',
    styleUrls: ['./cpw-task-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpwTaskLayoutComponent {
    private readonly positionsFacade = inject(UserPositionFacade);

    readonly activePositionTitle$ = this.positionsFacade.active$.pipe(
        map(position => (position?.name ? startCase(position.name) : ''))
    );
}
